"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialCaptionJobSchema = exports.SocialPublishMessageSchema = exports.SocialPostRetrySchema = exports.SocialPostCreateSchema = exports.SocialTailorRequestSchema = exports.SOCIAL_TAILOR_PARTS = exports.SocialEligibilitySchema = exports.SocialPolicyPutSchema = exports.SocialSandboxConnectSchema = exports.SocialSelectSchema = exports.SocialAppKeysPutSchema = exports.SOCIAL_APP_ACCESS_STATUSES = exports.SOCIAL_META_REVIEW_STATUSES = exports.SOCIAL_GOOGLE_ACCESS_STATUSES = exports.SocialAppKeyProviderSchema = exports.SOCIAL_APP_KEY_PROVIDERS = exports.SocialAdminOauthStartSchema = exports.SocialOauthStartSchema = exports.SocialTailorBatchSchema = exports.SocialPostSchema = exports.SocialPostTargetSchema = exports.SocialTargetErrorSchema = exports.SocialTargetStatusSchema = exports.SOCIAL_TARGET_STATUSES = exports.SocialPostStatusSchema = exports.SOCIAL_POST_STATUSES = exports.SocialPostSourceSchema = exports.SOCIAL_SOURCE_KINDS = exports.SocialConnectionSchema = exports.SocialConnectionStatusSchema = exports.SOCIAL_CONNECTION_STATUSES = exports.SocialAccountSchema = exports.SOCIAL_CAPTION_MAX = exports.SOCIAL_RUN_TARGET_TYPE = exports.SOCIAL_METER_PROVIDER_ID = exports.SOCIAL_PUBLISH_ACTION_IDS = exports.SOCIAL_CAPTION_ACTION_ID = exports.SOCIAL_IMAGE_ACTION_ID = exports.SOCIAL_CHANNEL_ASPECT = exports.SOCIAL_CHANNEL_LABELS = exports.SOCIAL_CHANNEL_PROVIDER = exports.SOCIAL_TAILOR_FEATURE = exports.SOCIAL_CHANNEL_FEATURES = exports.SocialProviderSchema = exports.SOCIAL_PROVIDERS = exports.SocialChannelSchema = exports.SOCIAL_CHANNELS = void 0;
exports.toSocialConnectionView = toSocialConnectionView;
exports.aggregateSocialPostStatus = aggregateSocialPostStatus;
/**
 * Ruby Social Publishing — channels, rows, request bodies, response shapes.
 * Spec: docs/superpowers/specs/2026-10-13-ruby-social-publishing-design.md
 * ADDITIVE ONLY: rows are stored in agenticpos-dynamodb-social-{connections,posts,policy}-<stage>.
 */
const zod_1 = require("zod");
exports.SOCIAL_CHANNELS = ['google_business', 'facebook', 'instagram'];
exports.SocialChannelSchema = zod_1.z.enum(exports.SOCIAL_CHANNELS);
exports.SOCIAL_PROVIDERS = ['google', 'meta', 'sandbox'];
exports.SocialProviderSchema = zod_1.z.enum(exports.SOCIAL_PROVIDERS);
/**
 * Each channel is its own feature in pkg_pos_marketing (owner decision).
 * 2026-10-13: Google is 'pos.marketing.google-business-photos' — 'pos.marketing.google-business'
 * is the Marketing (Nav) MENU feature and must never double as the Google publishing channel.
 */
exports.SOCIAL_CHANNEL_FEATURES = {
    google_business: 'pos.marketing.google-business-photos',
    facebook: 'pos.marketing.facebook',
    instagram: 'pos.marketing.instagram',
};
/** Ruby tailoring additionally needs the Ruby image actions feature. */
exports.SOCIAL_TAILOR_FEATURE = 'ai-image-actions';
exports.SOCIAL_CHANNEL_PROVIDER = {
    google_business: 'google', facebook: 'meta', instagram: 'meta',
};
exports.SOCIAL_CHANNEL_LABELS = {
    google_business: 'Google Business', facebook: 'Facebook', instagram: 'Instagram',
};
exports.SOCIAL_CHANNEL_ASPECT = {
    google_business: '4:3', facebook: '1:1', instagram: '4:5',
};
/** Ruby registry ids (all in AI_ACTION_IDS). */
exports.SOCIAL_IMAGE_ACTION_ID = 'image.social_post';
exports.SOCIAL_CAPTION_ACTION_ID = 'text.social_caption';
exports.SOCIAL_PUBLISH_ACTION_IDS = {
    google_business: 'social.publish.google_business',
    facebook: 'social.publish.facebook',
    instagram: 'social.publish.instagram',
};
/** Registry provider for posting; the vendor cost per post lives on MODEL#social#<channel>. */
exports.SOCIAL_METER_PROVIDER_ID = 'social';
/** RUN# target type for both tailoring runs and publish ledger lines. */
exports.SOCIAL_RUN_TARGET_TYPE = 'social_post';
exports.SOCIAL_CAPTION_MAX = 2200;
// ---------------------------------------------------------------- connections
exports.SocialAccountSchema = zod_1.z.object({
    channel: exports.SocialChannelSchema,
    /** Google: "accounts/{a}/locations/{l}"; Facebook: page id; Instagram: IG user id; sandbox: "sandbox-<channel>". */
    externalId: zod_1.z.string().min(1).max(300),
    name: zod_1.z.string().min(1).max(200),
    /** Set when the account serves ONE RubyTill location (Google Business listings). */
    locationId: zod_1.z.string().min(1).max(100).optional(),
    /** Listing details the channel supplied at connect time (additive, all optional) — the merchant's
     * Online Presence form fills its fields from these ("From Google" chips).
     * Google: Maps/profile URL, Place ID, CID. Facebook: page URL. Instagram: profile URL + username. */
    url: zod_1.z.string().max(500).optional(),
    placeId: zod_1.z.string().max(200).optional(),
    cid: zod_1.z.string().max(40).optional(),
    handle: zod_1.z.string().max(100).optional(),
});
exports.SOCIAL_CONNECTION_STATUSES = ['pending_selection', 'connected', 'needs_reauth', 'disconnected'];
exports.SocialConnectionStatusSchema = zod_1.z.enum(exports.SOCIAL_CONNECTION_STATUSES);
exports.SocialConnectionSchema = zod_1.z.object({
    tenantId: zod_1.z.string().min(1),
    connectionId: zod_1.z.string().min(1),
    provider: exports.SocialProviderSchema,
    channels: zod_1.z.array(exports.SocialChannelSchema).default([]),
    status: exports.SocialConnectionStatusSchema,
    locationIds: zod_1.z.array(zod_1.z.string()).default([]),
    accounts: zod_1.z.array(exports.SocialAccountSchema).default([]),
    candidates: zod_1.z.array(exports.SocialAccountSchema).optional(),
    /** AES-256-GCM blob of the provider tokens. NEVER returned to a client. */
    tokenCipher: zod_1.z.string().default(''),
    /** Who connected it. `email` + `bySuperAdmin` are set (additively) when a RubyTill super admin
     * connected it on the tenant's behalf from the Super Admin console. */
    connectedBy: zod_1.z.object({ sub: zod_1.z.string(), name: zod_1.z.string().optional(), email: zod_1.z.string().optional(), bySuperAdmin: zod_1.z.boolean().optional() }),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
function toSocialConnectionView(c) {
    const { tokenCipher: _omit, ...rest } = c;
    return rest;
}
// ---------------------------------------------------------------- posts
exports.SOCIAL_SOURCE_KINDS = ['product', 'creator_item', 'promotion', 'ad_slide', 'upload'];
exports.SocialPostSourceSchema = zod_1.z.object({
    kind: zod_1.z.enum(exports.SOCIAL_SOURCE_KINDS),
    id: zod_1.z.string().min(1).max(200).optional(),
    name: zod_1.z.string().min(1).max(200),
    /**
     * Final review I3 (additive): products this picture shows, when the client knows them (a Creator
     * Hub picture made from a product, an advertising slide or upload about a product). The server
     * ADDS these to whatever linkage it resolves itself — it can only tighten the restriction check,
     * never loosen it — so trusting the client here is safe.
     */
    productIds: zod_1.z.array(zod_1.z.string().min(1).max(100)).max(50).optional(),
});
exports.SOCIAL_POST_STATUSES = ['draft', 'queued', 'partial', 'posted', 'failed'];
exports.SocialPostStatusSchema = zod_1.z.enum(exports.SOCIAL_POST_STATUSES);
/** Spec lists queued·posting·posted·failed·blocked; 'draft' is added for targets of a saved draft. */
exports.SOCIAL_TARGET_STATUSES = ['draft', 'queued', 'posting', 'posted', 'failed', 'blocked'];
exports.SocialTargetStatusSchema = zod_1.z.enum(exports.SOCIAL_TARGET_STATUSES);
exports.SocialTargetErrorSchema = zod_1.z.object({ code: zod_1.z.string().min(1).max(60), message: zod_1.z.string().min(1).max(500) });
exports.SocialPostTargetSchema = zod_1.z.object({
    channel: exports.SocialChannelSchema,
    connectionId: zod_1.z.string(),
    accountId: zod_1.z.string(),
    accountName: zod_1.z.string().optional(),
    imageUrl: zod_1.z.string().url(),
    caption: zod_1.z.string().max(exports.SOCIAL_CAPTION_MAX),
    link: zod_1.z.string().url().optional(),
    status: exports.SocialTargetStatusSchema,
    externalPostId: zod_1.z.string().optional(),
    externalUrl: zod_1.z.string().nullable().optional(),
    error: exports.SocialTargetErrorSchema.optional(),
    sandbox: zod_1.z.boolean().optional(),
    attempts: zod_1.z.number().int().nonnegative().default(0),
    postingAt: zod_1.z.string().optional(),
    /** Fix round 2 (I3a/N1/N2): a fresh random id written by whichever worker claims/reclaims this
     * target (queued→posting, or stale posting→posting). Every later write for that claim — the
     * publishStartedAt write, the final posted/failed write, a revert back to queued — is
     * conditioned on `leaseId` still matching, so two workers that both think they hold the claim
     * can never both reach `adapter.publish()`: only one write of each step can succeed. */
    leaseId: zod_1.z.string().optional(),
    /** Set immediately before the adapter's publish() call starts (fix round 1, I3), conditioned on
     * `leaseId` (fix round 2). Its presence — on a STALE lease — is the ONLY signal that a target
     * found 'posting' on redelivery may have reached the channel; only then is it UNCONFIRMED. A
     * FRESH lease is always left alone regardless of publishStartedAt (another invocation still owns
     * it). Claim and reclaim always REMOVE this field, so a later attempt that dies before
     * `publish()` is never falsely reported UNCONFIRMED by a stale value from an earlier attempt. */
    publishStartedAt: zod_1.z.string().optional(),
    postedAt: zod_1.z.string().optional(),
});
exports.SocialPostSchema = zod_1.z.object({
    tenantId: zod_1.z.string().min(1),
    postId: zod_1.z.string().min(1),
    source: exports.SocialPostSourceSchema,
    locationId: zod_1.z.string().min(1),
    status: exports.SocialPostStatusSchema,
    targets: zod_1.z.array(exports.SocialPostTargetSchema).min(1).max(3),
    rubyRunIds: zod_1.z.array(zod_1.z.string()).optional(),
    createdBy: zod_1.z.object({ sub: zod_1.z.string(), name: zod_1.z.string().optional() }),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
function aggregateSocialPostStatus(targets) {
    const s = targets.map((t) => t.status);
    if (s.some((x) => x === 'queued' || x === 'posting'))
        return 'queued';
    if (s.some((x) => x === 'draft'))
        return 'draft';
    const posted = s.filter((x) => x === 'posted').length;
    if (posted === s.length)
        return 'posted';
    if (posted > 0)
        return 'partial';
    return 'failed';
}
/**
 * Ruby tailoring batch — stored in the social-posts table under postId "tailor#<batchId>".
 * It has NO createdAt, so the byCreated GSI (sparse) never lists it; `expiresAt` (epoch s) is the table TTL.
 */
exports.SocialTailorBatchSchema = zod_1.z.object({
    tenantId: zod_1.z.string().min(1),
    postId: zod_1.z.string().regex(/^tailor#/),
    kind: zod_1.z.literal('tailor'),
    batchId: zod_1.z.string().min(1),
    locationId: zod_1.z.string().min(1),
    channels: zod_1.z.array(exports.SocialChannelSchema).min(1),
    items: zod_1.z.array(zod_1.z.object({
        channel: exports.SocialChannelSchema,
        runId: zod_1.z.string().nullable(),
        error: zod_1.z.string().nullable(),
    })),
    caption: zod_1.z.object({
        status: zod_1.z.enum(['running', 'succeeded', 'failed', 'skipped']),
        byChannel: zod_1.z.record(zod_1.z.string()).default({}),
        error: zod_1.z.string().nullable().default(null),
    }),
    startedAt: zod_1.z.string(),
    expiresAt: zod_1.z.number().int(),
    /** Final review I5 (additive): set by the caption worker's conditional `running` claim, before it
     * reserves any Ruby Tokens. A batch can be claimed once; the poll's timeout never overrides a
     * claim that is still inside the worker's own run window. */
    captionClaimedAt: zod_1.z.string().optional(),
});
// ---------------------------------------------------------------- request bodies
exports.SocialOauthStartSchema = zod_1.z.object({
    locationId: zod_1.z.string().min(1).max(100),
    /** window.location.origin of the app; only allow-listed origins are honoured. */
    returnTo: zod_1.z.string().url().optional(),
});
/** Super Admin console: same as the merchant start + the location REQUEST id, so the callback can
 * send the admin back to /tenant/{tenantId}/location/{requestId}?tab=online. */
exports.SocialAdminOauthStartSchema = exports.SocialOauthStartSchema.extend({
    requestId: zod_1.z.string().regex(/^[A-Za-z0-9_-]{1,128}$/),
});
// ---------------------------------------------------------------- RubyTill's own app keys (super admin)
/** RubyTill's OWN Google Cloud / Meta app credentials — one set per stage, kept in SSM. */
exports.SOCIAL_APP_KEY_PROVIDERS = ['google', 'meta'];
exports.SocialAppKeyProviderSchema = zod_1.z.enum(exports.SOCIAL_APP_KEY_PROVIDERS);
/** Google: Business Profile API access request. */
exports.SOCIAL_GOOGLE_ACCESS_STATUSES = ['not_requested', 'requested', 'approved'];
/** Meta: App Review. */
exports.SOCIAL_META_REVIEW_STATUSES = ['not_submitted', 'submitted', 'approved'];
exports.SOCIAL_APP_ACCESS_STATUSES = {
    google: exports.SOCIAL_GOOGLE_ACCESS_STATUSES,
    meta: exports.SOCIAL_META_REVIEW_STATUSES,
};
/** PUT /social/admin/app-keys/{provider}. `appId` is accepted as an alias of `clientId` (Meta's word).
 * `secret` is WRITE-ONLY — no response ever carries it. */
exports.SocialAppKeysPutSchema = zod_1.z.object({
    clientId: zod_1.z.string().trim().min(1).max(300).optional(),
    appId: zod_1.z.string().trim().min(1).max(300).optional(),
    secret: zod_1.z.string().trim().min(1).max(500).optional(),
    accessStatus: zod_1.z.enum([...exports.SOCIAL_GOOGLE_ACCESS_STATUSES, ...exports.SOCIAL_META_REVIEW_STATUSES]).optional(),
});
exports.SocialSelectSchema = zod_1.z.object({
    accounts: zod_1.z.array(exports.SocialAccountSchema).min(1).max(30),
    locationIds: zod_1.z.array(zod_1.z.string().min(1).max(100)).min(1).max(200),
});
exports.SocialSandboxConnectSchema = zod_1.z.object({
    locationId: zod_1.z.string().min(1).max(100),
    channels: zod_1.z.array(exports.SocialChannelSchema).min(1),
});
exports.SocialPolicyPutSchema = zod_1.z.object({
    categoryId: zod_1.z.string().min(1).max(100),
    blocked: zod_1.z.array(exports.SocialChannelSchema),
});
exports.SocialEligibilitySchema = zod_1.z.object({
    /** Absent = evaluate at every location with a connected channel. */
    locationId: zod_1.z.string().min(1).max(100).optional(),
    productIds: zod_1.z.array(zod_1.z.string().min(1).max(100)).min(1).max(50),
});
exports.SOCIAL_TAILOR_PARTS = ['image', 'caption'];
exports.SocialTailorRequestSchema = zod_1.z.object({
    locationId: zod_1.z.string().min(1).max(100),
    source: exports.SocialPostSourceSchema,
    channels: zod_1.z.array(exports.SocialChannelSchema).min(1).max(3),
    imageUrl: zod_1.z.string().url(),
    prompt: zod_1.z.string().max(400).default(''),
    description: zod_1.z.string().max(600).optional(),
    link: zod_1.z.string().url().optional(),
    parts: zod_1.z.array(zod_1.z.enum(exports.SOCIAL_TAILOR_PARTS)).min(1).default(['image', 'caption']),
    clientKey: zod_1.z.string().min(8).max(80),
});
exports.SocialPostCreateSchema = zod_1.z.object({
    source: exports.SocialPostSourceSchema,
    locationId: zod_1.z.string().min(1).max(100),
    postNow: zod_1.z.boolean(),
    rubyRunIds: zod_1.z.array(zod_1.z.string().max(100)).max(10).optional(),
    targets: zod_1.z.array(zod_1.z.object({
        channel: exports.SocialChannelSchema,
        imageUrl: zod_1.z.string().url(),
        caption: zod_1.z.string().max(exports.SOCIAL_CAPTION_MAX),
        link: zod_1.z.string().url().optional(),
    })).min(1).max(3),
    clientKey: zod_1.z.string().min(8).max(80),
});
/**
 * Final review I1: POST /social/posts/{id}/retry body (optional — an empty body keeps the old
 * behaviour for failed/draft targets EXCEPT `UNCONFIRMED` ones). `targetIndexes` / `channels`
 * narrow the retry to those targets. A target that failed `UNCONFIRMED` (it may already be live)
 * is only re-sent when `confirmUnconfirmed` is true — otherwise the answer lists it under
 * `needsConfirm` and nothing is sent for it.
 */
exports.SocialPostRetrySchema = zod_1.z.object({
    targetIndexes: zod_1.z.array(zod_1.z.number().int().min(0).max(2)).max(3).optional(),
    channels: zod_1.z.array(exports.SocialChannelSchema).max(3).optional(),
    confirmUnconfirmed: zod_1.z.boolean().optional(),
});
/** One SocialPublishQueue message = one target of one post. */
exports.SocialPublishMessageSchema = zod_1.z.object({
    tenantId: zod_1.z.string().min(1),
    postId: zod_1.z.string().min(1),
    targetIndex: zod_1.z.number().int().min(0).max(2),
});
/** Async payload of the captionWorker Lambda. */
exports.SocialCaptionJobSchema = zod_1.z.object({
    tenantId: zod_1.z.string().min(1),
    batchId: zod_1.z.string().min(1),
    actor: zod_1.z.object({ sub: zod_1.z.string(), email: zod_1.z.string().optional(), name: zod_1.z.string().optional() }),
    channels: zod_1.z.array(exports.SocialChannelSchema).min(1),
    sourceName: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    prompt: zod_1.z.string(),
    link: zod_1.z.string().optional(),
    locationId: zod_1.z.string(),
});
//# sourceMappingURL=social.js.map